export class EmployeeTypeFieldParameter {
  // no definition. the field contains always the own employee number. it is required to have one to use rbb forms.
}
